import * as React from 'react';
import type {ChatPanelHandle} from './chat-panel';
import {create} from 'zustand';


export const useAutoAttachStore = create<{
  shouldAutoAttach: boolean;
  setShouldAutoAttach: (value: boolean) => void;
  headerSlot: React.ReactNode | null;
  setHeaderSlot: (node: React.ReactNode | null) => void;
}>((set) => ({
  shouldAutoAttach: false,
  setShouldAutoAttach: (value) => set({shouldAutoAttach: value}),
  headerSlot: null,
  setHeaderSlot: (node) => set({headerSlot: node}),
}));

export const useRespondToAutoAttach = (
  chatPanelRef: React.RefObject<ChatPanelHandle | null>,
) => {
  const {shouldAutoAttach, headerSlot} = useAutoAttachStore();

  React.useEffect(() => {
    if (shouldAutoAttach) {
      chatPanelRef.current?.setMode('attached');
    } else {
      // restore last non-attached mode (floating/fullscreen/hidden)
      let fallback: 'floating' | 'fullscreen' | 'hidden' = 'hidden';
      try {
        const persisted = (localStorage.getItem('chatMode') || 'floating') as
          | 'floating'
          | 'fullscreen'
          | 'hidden'
          | 'attached';
        if (
          persisted === 'floating' ||
          persisted === 'fullscreen' ||
          persisted === 'hidden'
        ) {
          fallback = persisted;
        }
      } catch {}
      chatPanelRef.current?.setMode(fallback);
    }
  }, [shouldAutoAttach]);
  //for now headerSlot is only used in attached mode
  //change later if needed
  return {headerSlot: shouldAutoAttach ? headerSlot : null};
};

export const useRequestToAutoAttach = () => {
  const {setShouldAutoAttach} = useAutoAttachStore();

  React.useEffect(() => {
    setShouldAutoAttach(true);
    return () => {
      setShouldAutoAttach(false);
    };
  }, []);
};

export const useHeaderSlot = (headerSlot: React.ReactNode | null) => {
  const {setHeaderSlot} = useAutoAttachStore();
  React.useEffect(() => {
    setHeaderSlot(headerSlot);
    return () => {
      setHeaderSlot(null);
    };
  }, [headerSlot]);
};
